import { diff } from 'diffblazer';

export function diffHtml(oldHtml: string, newHtml: string) {
  return diff(oldHtml, newHtml, {
    markers: {
      insert: {
        start: `<ins>`,
        end: `</ins>`,
      },
      delete: {
        start: `<del>`,
        end: `</del>`,
      },
      modify: {
        start: '',
        end: '',
      },
      replaceDelete: {
        start: `<del>`,
        end: `</del>`,
      },
      replaceInsert: {
        start: `<ins>`,
        end: `</ins>`,
      },
    },
  });
}
